import { render } from "./ValidationErrors.vue?vue&type=template&id=6490a178"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"
script.render = render

export default script